// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://emyfvhrhwuhlmxewvcyk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVteWZ2aHJod3VobG14ZXd2Y3lrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg1NjA2ODksImV4cCI6MjA3NDEzNjY4OX0.PkqmWUFj2bpiFImTAcD1MGsyJKfYVQ3wdGoY0QNMKog";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});